import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "updatepassword";

const initialState = {
  loading: null,
  usersList: [],
  usersResponse: {},
  errorMessage: "",
};

// GET
export const getUsersFromServer = createAsyncThunk(
  `${namespace}/getUsersFromServer`,
  async () => {
    const response = await api.get("/users", {
      headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
    });
    return response.data;
  }
);

// PATCH
export const updateUserPassword = createAsyncThunk(
  `${namespace}/updateUserPassword`,
  async (updatedPassword) => {
    const response = await api.patch("/resetuserpassword", updatedPassword, {
      headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
    });
    return response.data;
  }
);

export const UpdatePasswordSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsersFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getUsersFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.usersList = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getUsersFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.usersList = [];
        state.errorMessage = error.errorMessage;
      })
      .addCase(updateUserPassword.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(updateUserPassword.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.usersResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(updateUserPassword.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.usersResponse = {};
        state.errorMessage = error.errorMessage;
      });
  },
});

export const selectAllUsers = (state) => state.resetpassword.usersList;
export const selectLoadingStatus = (state) => state.resetpassword.loading;
export default UpdatePasswordSlice.reducer;
